import { useCustomerPortalNoIndex } from '../../hooks/useNoIndex'

/**
 * Applies noindex to token-based and transactional customer-portal routes.
 */
export function CustomerPortalNoIndex(): null {
  useCustomerPortalNoIndex()
  return null
}

export default CustomerPortalNoIndex
